/**
 * Contract status as the design's five tones.
 *
 * The screen used to carry its own Tailwind colour map (bg-blue-100 for sent,
 * bg-amber-100 for expired and so on), which meant "waiting" was a different
 * amber here than on every other CRM list. `StatusPill` already owns that
 * meaning, so a status only has to say which of the five tones it is.
 */
import type { StatusTone } from "../../ui";
import type { ContractStatus } from "../../../lib/projects";

export const STATUSES: ContractStatus[] = ["draft", "sent", "active", "expired", "terminated"];

/**
 * ok = in force, info = out with the client, wt = ran out and wants a decision,
 * lt = called off, mut = not sent yet.
 *
 * Expired is `wt` rather than `lt` deliberately: a contract that ran its term is
 * not a failure, it is a renewal nobody has made yet. Terminated is the one that
 * ended badly, and it should not share a colour with the ordinary end of a term.
 */
const TONE: Record<ContractStatus, StatusTone> = {
  draft: "mut",
  sent: "info",
  active: "ok",
  expired: "wt",
  terminated: "lt",
};

export function statusTone(s: ContractStatus): StatusTone {
  return TONE[s];
}
